import React, { useState } from 'react';

// Virtual Gifts Collection for Flirteen Premium Users
const VirtualGifts = ({ onSendGift, userType = 'premium' }) => {
  const [selectedCategory, setSelectedCategory] = useState('romantic');
  const [selectedGift, setSelectedGift] = useState(null);

  // Virtual Gifts Database
  const giftCategories = {
    romantic: {
      name: "💕 Romantic",
      color: "#FF6B6B",
      gifts: [
        {
          id: 'red_rose',
          name: 'Red Rose',
          emoji: '🌹',
          animation: 'float',
          price: 10,
          rarity: 'common',
          description: 'A classic symbol of love and romance',
          effect: 'sparkle'
        },
        {
          id: 'bouquet',
          name: 'Rose Bouquet',
          emoji: '💐',
          animation: 'bounce',
          price: 25,
          rarity: 'uncommon',
          description: 'A beautiful bouquet to sweep them off their feet',
          effect: 'hearts'
        },
        {
          id: 'love_letter',
          name: 'Love Letter',
          emoji: '💌',
          animation: 'pulse',
          price: 15,
          rarity: 'common',
          description: 'Express your feelings with a heartfelt message',
          effect: 'glow'
        },
        {
          id: 'diamond_ring',
          name: 'Diamond Ring',
          emoji: '💍',
          animation: 'shine',
          price: 100,
          rarity: 'legendary',
          description: 'The ultimate romantic gesture',
          effect: 'rainbow'
        },
        {
          id: 'chocolate_box',
          name: 'Chocolate Box',
          emoji: '🍫',
          animation: 'wiggle',
          price: 20,
          rarity: 'common',
          description: 'Sweet treats for your sweet person',
          effect: 'sparkle'
        }
      ]
    },
    luxury: {
      name: "✨ Luxury",
      color: "#FFD700",
      gifts: [
        {
          id: 'champagne',
          name: 'Champagne',
          emoji: '🥂',
          animation: 'bubble',
          price: 50,
          rarity: 'rare',
          description: 'Celebrate special moments together',
          effect: 'bubbles'
        },
        {
          id: 'sports_car',
          name: 'Sports Car',
          emoji: '🏎️',
          animation: 'zoom',
          price: 200,
          rarity: 'legendary',
          description: 'Take them on a virtual joyride',
          effect: 'speed_lines'
        },
        {
          id: 'yacht',
          name: 'Luxury Yacht',
          emoji: '🛥️',
          animation: 'wave',
          price: 300,
          rarity: 'legendary',
          description: 'Sail away to paradise together',
          effect: 'waves'
        },
        {
          id: 'crown',
          name: 'Golden Crown',
          emoji: '👑',
          animation: 'shine',
          price: 75,
          rarity: 'rare',
          description: 'Make them feel like royalty',
          effect: 'golden_sparkle'
        },
        {
          id: 'designer_bag',
          name: 'Designer Handbag',
          emoji: '👜',
          animation: 'swing',
          price: 60,
          rarity: 'uncommon',
          description: 'A touch of luxury and style',
          effect: 'sparkle'
        }
      ]
    },
    cute: {
      name: "🐾 Cute & Fun",
      color: "#FF69B4",
      gifts: [
        {
          id: 'teddy_bear',
          name: 'Teddy Bear',
          emoji: '🧸',
          animation: 'hug',
          price: 30,
          rarity: 'common',
          description: 'A cuddly companion to show you care',
          effect: 'hearts'
        },
        {
          id: 'unicorn',
          name: 'Magical Unicorn',
          emoji: '🦄',
          animation: 'gallop',
          price: 45,
          rarity: 'rare',
          description: 'Bring some magic into their day',
          effect: 'rainbow'
        },
        {
          id: 'puppy',
          name: 'Cute Puppy',
          emoji: '🐶',
          animation: 'wag',
          price: 35,
          rarity: 'uncommon',
          description: 'An adorable furry friend',
          effect: 'paw_prints'
        },
        {
          id: 'kitten',
          name: 'Fluffy Kitten',
          emoji: '🐱',
          animation: 'purr',
          price: 35,
          rarity: 'uncommon',
          description: 'Purr-fect for cat lovers',
          effect: 'sparkle'
        },
        {
          id: 'balloon',
          name: 'Heart Balloon',
          emoji: '🎈',
          animation: 'float',
          price: 12,
          rarity: 'common',
          description: 'Light up their day with joy',
          effect: 'float'
        }
      ]
    },
    food: {
      name: "🍕 Treats",
      color: "#FF8C00",
      gifts: [
        {
          id: 'birthday_cake',
          name: 'Birthday Cake',
          emoji: '🎂',
          animation: 'candles',
          price: 40,
          rarity: 'uncommon',
          description: 'Celebrate special moments',
          effect: 'confetti'
        },
        {
          id: 'pizza',
          name: 'Pizza Slice',
          emoji: '🍕',
          animation: 'steam',
          price: 18,
          rarity: 'common',
          description: 'Share a virtual meal together',
          effect: 'steam'
        },
        {
          id: 'ice_cream',
          name: 'Ice Cream',
          emoji: '🍦',
          animation: 'drip',
          price: 15,
          rarity: 'common',
          description: 'Cool treat for hot days',
          effect: 'sparkle'
        },
        {
          id: 'donut',
          name: 'Glazed Donut',
          emoji: '🍩',
          animation: 'spin',
          price: 12,
          rarity: 'common',
          description: 'Sweet and delightful',
          effect: 'glaze'
        },
        {
          id: 'cocktail',
          name: 'Tropical Cocktail',
          emoji: '🍹',
          animation: 'stir',
          price: 25,
          rarity: 'uncommon',
          description: 'Cheers to good times',
          effect: 'bubbles'
        }
      ]
    },
    special: {
      name: "🌟 Special",
      color: "#8A2BE2",
      gifts: [
        {
          id: 'shooting_star',
          name: 'Shooting Star',
          emoji: '🌠',
          animation: 'streak',
          price: 80,
          rarity: 'rare',
          description: 'Make a wish together',
          effect: 'star_trail'
        },
        {
          id: 'rainbow',
          name: 'Rainbow',
          emoji: '🌈',
          animation: 'arc',
          price: 55,
          rarity: 'rare',
          description: 'Brighten up their world',
          effect: 'rainbow'
        },
        {
          id: 'fireworks',
          name: 'Fireworks',
          emoji: '🎆',
          animation: 'explode',
          price: 65,
          rarity: 'rare',
          description: 'Celebrate in spectacular style',
          effect: 'explosion'
        },
        {
          id: 'trophy',
          name: 'Golden Trophy',
          emoji: '🏆',
          animation: 'shine',
          price: 70,
          rarity: 'rare',
          description: 'They deserve to be celebrated',
          effect: 'golden_sparkle'
        },
        {
          id: 'magic_wand',
          name: 'Magic Wand',
          emoji: '🪄',
          animation: 'spell',
          price: 90,
          rarity: 'legendary',
          description: 'Cast a spell of love and wonder',
          effect: 'magic_sparkle'
        }
      ]
    }
  };

  const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'common': return '#95A5A6';
      case 'uncommon': return '#2ECC71';
      case 'rare': return '#3498DB';
      case 'legendary': return '#9B59B6';
      default: return '#95A5A6';
    }
  };

  const getRarityBadge = (rarity) => {
    switch (rarity) {
      case 'common': return '🔘';
      case 'uncommon': return '🟢';
      case 'rare': return '🔵';
      case 'legendary': return '🟣';
      default: return '🔘';
    }
  };

  const handleGiftSelect = (gift) => {
    setSelectedGift(gift);
  };

  const handleSendGift = (gift) => {
    if (onSendGift) {
      onSendGift(gift);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      borderRadius: '20px',
      padding: '25px',
      color: 'white',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '25px' }}>
        <h2 style={{
          fontSize: '1.8rem',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #FF6B6B 0%, #00E9FF 50%, #8A2BE2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px'
        }}>
          <span style={{
            fontSize: '2rem',
            background: 'linear-gradient(45deg, #FFD700, #FF6B6B)',
            borderRadius: '50%',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '40px',
            height: '40px',
            fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, Android Emoji, EmojiSymbols, system-ui, sans-serif'
          }}>🎁</span>
          Virtual Gifts
        </h2>
        <p style={{
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '1rem',
          margin: 0
        }}>
          Send premium virtual gifts to show you care ✨
        </p>
      </div>

      {/* Category Tabs */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '20px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {Object.keys(giftCategories).map((categoryKey) => {
          const category = giftCategories[categoryKey];
          const isActive = selectedCategory === categoryKey;
          
          return (
            <button
              key={categoryKey}
              onClick={() => setSelectedCategory(categoryKey)}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                background: isActive 
                  ? category.color 
                  : 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
            >
              {category.name}
            </button>
          );
        })}
      </div>

      {/* Gifts Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '15px',
        marginBottom: '20px'
      }}>
        {giftCategories[selectedCategory].gifts.map((gift) => (
          <div
            key={gift.id}
            onClick={() => handleGiftSelect(gift)}
            style={{
              background: selectedGift?.id === gift.id 
                ? 'rgba(255, 255, 255, 0.2)' 
                : 'rgba(255, 255, 255, 0.1)',
              border: selectedGift?.id === gift.id 
                ? `2px solid ${giftCategories[selectedCategory].color}` 
                : '2px solid transparent',
              borderRadius: '15px',
              padding: '15px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative'
            }}
            onMouseOver={(e) => {
              if (selectedGift?.id !== gift.id) {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
              }
            }}
            onMouseOut={(e) => {
              if (selectedGift?.id !== gift.id) {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              }
            }}
          >
            {/* Rarity Badge */}
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              fontSize: '0.8rem'
            }}>
              {getRarityBadge(gift.rarity)}
            </div>

            {/* Gift Emoji */}
            <div style={{
              fontSize: '3rem',
              marginBottom: '8px',
              fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, Android Emoji, EmojiSymbols, system-ui, sans-serif',
              textRendering: 'optimizeQuality',
              WebkitFontSmoothing: 'antialiased',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '60px',
              width: '60px',
              margin: '0 auto 8px auto',
              background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
              borderRadius: '50%',
              animation: gift.animation === 'float' ? 'float 2s ease-in-out infinite' :
                        gift.animation === 'bounce' ? 'bounce 1s ease-in-out infinite' :
                        gift.animation === 'pulse' ? 'pulse 2s ease-in-out infinite' :
                        'none'
            }}>
              {gift.emoji}
            </div>

            {/* Gift Name */}
            <h4 style={{
              fontSize: '0.9rem',
              fontWeight: '600',
              margin: '0 0 4px 0',
              color: 'white'
            }}>
              {gift.name}
            </h4>

            {/* Price */}
            <div style={{
              color: '#FFD700',
              fontSize: '0.8rem',
              fontWeight: '600',
              marginBottom: '6px'
            }}>
              💎 {gift.price} coins
            </div>

            {/* Rarity */}
            <div style={{
              fontSize: '0.7rem',
              color: getRarityColor(gift.rarity),
              fontWeight: '500',
              textTransform: 'capitalize'
            }}>
              {gift.rarity}
            </div>
          </div>
        ))}
      </div>

      {/* Selected Gift Details */}
      {selectedGift && (
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '15px',
          padding: '20px',
          marginBottom: '15px',
          border: `2px solid ${giftCategories[selectedCategory].color}`
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{ 
              fontSize: '3rem',
              fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, Android Emoji, EmojiSymbols, system-ui, sans-serif',
              textRendering: 'optimizeQuality',
              WebkitFontSmoothing: 'antialiased',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '60px'
            }}>
              {selectedGift.emoji}
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{
                margin: '0 0 5px 0',
                fontSize: '1.2rem',
                color: 'white'
              }}>
                {selectedGift.name}
              </h3>
              <p style={{
                margin: '0 0 8px 0',
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '0.9rem'
              }}>
                {selectedGift.description}
              </p>
              <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                <span style={{ color: '#FFD700', fontWeight: '600' }}>
                  💎 {selectedGift.price} coins
                </span>
                <span style={{ 
                  color: getRarityColor(selectedGift.rarity),
                  fontSize: '0.8rem',
                  textTransform: 'capitalize'
                }}>
                  {getRarityBadge(selectedGift.rarity)} {selectedGift.rarity}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send Button */}
      {selectedGift && (
        <button
          onClick={() => handleSendGift(selectedGift)}
          style={{
            width: '100%',
            padding: '15px',
            background: `linear-gradient(135deg, ${giftCategories[selectedCategory].color}, #8A2BE2)`,
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            fontFamily: 'inherit'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 10px 30px rgba(255, 107, 107, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Send Gift 🎁
        </button>
      )}

      {/* Premium Badge */}
      <div style={{
        textAlign: 'center',
        marginTop: '15px',
        padding: '8px',
        background: 'linear-gradient(90deg, #FFD700, #FF6B6B)',
        borderRadius: '8px',
        fontSize: '0.8rem',
        fontWeight: '600'
      }}>
        💎 Premium Feature - Exclusive for Premium Members
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `}</style>
    </div>
  );
};

export default VirtualGifts;